import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        dark: true,
        themes: {
            dark: {
                primary: '#e1a732',
                secondary: '#e4e4e4'
            }
        }
    },
    breakpoint: {
        thresholds: {
            xs: 601,
            sm: 960,
            md: 1264,
            lg: 1904,
        }
    }
});
